import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to detect email confirmation across tabs
 * Listens for:
 * 1. Supabase auth events (SIGNED_IN)
 * 2. postMessage from callback tab
 * 3. localStorage fallback
 */
export function useEmailConfirmation(onConfirmed: () => void) {
  useEffect(() => {
    // 1) Supabase auth event listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session?.user) {
        onConfirmed();
      }
    });

    // 2) postMessage from /auth/callback tab
    const handleMessage = (event: MessageEvent) => {
      if (event?.data?.source === 'safurra' && event?.data?.type === 'email_confirmed') {
        onConfirmed();
      }
    };
    window.addEventListener('message', handleMessage);

    // 3) localStorage fallback for cases where postMessage doesn't work
    const checkLocalStorage = () => {
      if (localStorage.getItem('safurra_email_confirmed') === '1') {
        localStorage.removeItem('safurra_email_confirmed');
        onConfirmed();
      }
    };
    
    // Check immediately and also on storage changes
    checkLocalStorage();
    window.addEventListener('storage', checkLocalStorage);

    return () => {
      subscription.unsubscribe();
      window.removeEventListener('message', handleMessage);
      window.removeEventListener('storage', checkLocalStorage);
    };
  }, [onConfirmed]);
}